import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [chargement, setChargement] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setChargement(true);
    setErreur('');
    try {
      const res = await API.post('/auth/login', { email, mot_de_passe: motDePasse });
      login(res.data.token, res.data.utilisateur);
      navigate('/dashboard');
    } catch (err) {
      setErreur('Email ou mot de passe incorrect.');
    } finally {
      setChargement(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <img src="/logovert.png" alt="SOGAS" style={styles.logo} />
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {erreur && <div style={styles.erreur}>{erreur}</div>}
          <div style={styles.champ}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="votre@email.sn"
              required
            />
          </div>
          <div style={styles.champ}>
            <label style={styles.label}>Mot de passe</label>
            <input
              type="password"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            style={chargement ? styles.boutonDisabled : styles.bouton}
            disabled={chargement}
          >
            {chargement ? 'Connexion...' : 'SE CONNECTER'}
          </button>
        </form>

        <div style={styles.footerBox}>
          <p style={styles.footer}>© 2026 SOGAS — Tous droits réservés</p>
          <p style={styles.dev}>Développé par <strong>Abdoul Aziz Talla</strong></p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#F4F6F9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '40px',
    width: '420px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    borderTop: '6px solid #2E7D32',
  },
  header: {
    textAlign: 'center',
    marginBottom: '28px',
  },
  logo: {
    width: '200px',
    height: 'auto',
    objectFit: 'contain',
    marginBottom: '8px',
  },
  sousTitre: {
    color: '#9E9E9E',
    fontSize: '13px',
    marginTop: '4px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  champ: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    color: '#616161',
    fontWeight: '600',
    fontSize: '13px',
  },
  input: {
    padding: '10px 12px',
    borderRadius: '7px',
    border: '1px solid #E0E0E0',
    fontSize: '14px',
    outline: 'none',
    height: '40px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  bouton: {
    backgroundColor: '#2E7D32',
    color: '#ffffff',
    padding: '11px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    marginTop: '8px',
    width: '100%',
    height: '42px',
    letterSpacing: '0.5px',
  },
  boutonDisabled: {
    backgroundColor: '#9E9E9E',
    color: '#ffffff',
    padding: '11px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '15px',
    cursor: 'not-allowed',
    marginTop: '8px',
    width: '100%',
    height: '42px',
  },
  erreur: {
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    padding: '10px 12px',
    borderRadius: '7px',
    border: '1px solid #EF9A9A',
    fontSize: '13px',
    textAlign: 'center',
  },
  footerBox: {
    textAlign: 'center',
    marginTop: '24px',
    borderTop: '1px solid #E0E0E0',
    paddingTop: '14px',
  },
  footer: {
    color: '#9E9E9E',
    fontSize: '12px',
    margin: '0 0 4px 0',
  },
  dev: {
    color: '#616161',
    fontSize: '12px',
    margin: 0,
  },
};

export default LoginPage;
